import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import urls from 'constants/urls';

import CustomAisle from 'components/CustomAisle';
import NotFound from 'components/NotFound/NotFound';
import Redirect from 'components/Redirect';

const Featured = () => {
  const { search } = useLocation();

  return (
    <Routes>
      <Route
        path="groceries"
        element={<Redirect to={{ pathname: urls.groceriesHome, search }} replace />}
      />
      <Route
        path="entertaining"
        element={<Redirect to={{ pathname: urls.entertainingHome, search }} replace />}
      />
      <Route path="offers" element={<Redirect to={{ pathname: urls.offers, search }} replace />} />
      <Route path={'groceries/*'} element={<CustomAisle rootCategory="groceries" />} />
      <Route path={'entertaining/*'} element={<CustomAisle rootCategory="entertaining" />} />
      <Route path={'offers/*'} element={<CustomAisle rootCategory="offers" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Featured;
